/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { bookmarksStatuses, docViewModes } from "constants/enums";
import { getViewMode, getIsInPlaceMode } from "selectors/viewModeSelectors";
import { isSinglePageMode, getShouldUnblockUIFeatures, isFitOneFullPageMode } from "selectors/documentSelectors";

export const getBookmarks = stores => stores.bookmarkStore.bookmarks;
export const getHasBookmarksFromMetadata = stores => stores.documentStore.hasBookmarks;
export const getHasBookmarks = stores => stores.bookmarkStore.bookmarksStatus > bookmarksStatuses.NOT_PRESENT;
export const shouldShowBookmarksIcon = stores =>
  (getViewMode(stores) === docViewModes.CLASSIC_VIEW ||
    getIsInPlaceMode(stores) ||
    isSinglePageMode(stores) ||
    isFitOneFullPageMode(stores)) &&
  shouldEnableBookmarks(stores) &&
  getHasBookmarks(stores);
export const shouldDisableBookmarksIcon = stores => !(getShouldUnblockUIFeatures(stores) && getHasBookmarks(stores));

export const shouldEnableBookmarks = stores => stores.bookmarkStore.shouldEnableBookmarks;
export const getActionsUsingBookmarkId = (stores, id) => stores.bookmarkStore.bookmarkIdToActions.get(id);
export const getBookmarksStatus = stores => stores.bookmarkStore.bookmarksStatus;
